import * as utils from '../utils';
export function getArguments(node) {
    return node.arguments;
}
export function getArgumentsArray(node) {
    return utils.getArray(node.arguments);
}
export function getTypeArguments(node) {
    return utils.getValueOrUndefined(node.typeArguments);
}
export function getTypeArgumentsArray(node) {
    return utils.getArray(getTypeArguments(node));
}

//# sourceMappingURL=argumented.js.map
